import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
@Pipe({
  name: 'facebook',
  standalone: true
})
export class FacebookPipe implements PipeTransform {
  constructor(private dom: DomSanitizer) {

  }
  transform(_url: any, args?: any): any {
    if (!_url) { return ''; }
    if (_url) {
      _url = 'https://www.facebook.com/plugins/video.php?href=' + encodeURIComponent(_url) + '&appId=2665727906795083&width=370&height=210&show_text=false';
    }
    return this.dom.bypassSecurityTrustResourceUrl(_url);
  }

}
